export default {
  CALENDAR: 'calendar',
  LIST: 'list',
};
